module.exports = __webpack_public_path__ + "img/male.f44552b5.png";